export default __webpack_public_path__ + "384a3ccc09fdc2ada6f405f4d2b2becb.png";